import './CartMilestone.scss';

import { object } from 'prop-types';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import { RichText } from '@sitecore-jss/sitecore-jss-react';

const CartMilestone = ({ message, currentCart }) => {
  const cartMilestone = useMemo(() => {
    return currentCart?.Milestone;
  }, [currentCart]);

  const cartMilestoneProgress = useMemo(() => {
    return (cartMilestone?.Progress ?? 0) * 100;
  }, [cartMilestone]);

  const messageConvertedData = useMemo(() => {
    const nextTiers = cartMilestone?.NextTier;
    const prize = cartMilestone?.Prize;

    return message?.value
      ? {
        ...message,
        value: message.value?.replace('{amount}', nextTiers)?.replace('{prize}', prize)
      }
      : {
        value: ''
      };
  }, [message, cartMilestone]);

  return cartMilestone ? (
    <div className='cart-milestone'>
      <RichText field={messageConvertedData} tag='p' className='cart-milestone__message' />
      <div className='cart-milestone__progress-container'>
        <div className='cart-milestone__progress-body' style={{ '--progressWidth': `${cartMilestoneProgress}%` }}></div>
      </div>
    </div>
  ) : (
    <></>
  );
};

CartMilestone.propTypes = {
  message: object,
  currentCart: object
};

const mapStateToProps = (state) => ({
  currentCart: state.productReducer.cartDetailReducer.currentCart
});

export default connect(mapStateToProps)(CartMilestone);
